import { useState } from 'react'
import { message } from 'antd'
import type { Notification } from '../types/notification.types'

export const useNotificationActions = () => {
    const [selectedNotification, setSelectedNotification] = useState<Notification | null>(null)
    const [isDetailDrawerOpen, setIsDetailDrawerOpen] = useState(false)
    const [isSendModalOpen, setIsSendModalOpen] = useState(false)

    const handleViewDetails = (notification: Notification) => {
        setSelectedNotification(notification)
        setIsDetailDrawerOpen(true)
    }

    const openSendModal = () => setIsSendModalOpen(true)
    const closeSendModal = () => setIsSendModalOpen(false)

    const handleSendNotification = (values: any) => {
        console.log('Sending notification:', values)
        message.success('Notification sent successfully!')
        closeSendModal()
    }

    const handleRetryNotification = (notification: Notification) => {
        message.success(`Retrying notification ${notification.id}`)
    }
    
    const closeDrawer = () => setIsDetailDrawerOpen(false)

    return {
        selectedNotification,
        isDetailDrawerOpen,
        isSendModalOpen,
        handleViewDetails,
        openSendModal,
        closeSendModal,
        handleSendNotification,
        handleRetryNotification,
        closeDrawer
    }
}
